import { createFormatForDescription as cffd } from '../createFormatForDescription'
import CurrencyAmount from '../types/util/CurrencyAmount'

/**
 * Creates a short string explanation of an amount of currency.
 *
 * @param amount - The amount of currency.
 * @returns The explanation of the amount of currency.
 */
export default function explainAmount(amount: CurrencyAmount): string {
  if (typeof amount === 'string') {
    return `${cffd(amount, 'amount-value')} drops of XRP`
  }
  return `${cffd(amount.value, 'amount-value')} ${cffd(
    amount.currency,
    'amount-currency',
  )} (issued by ${cffd(amount.issuer, 'amount-issuer')})`
}
